/*eslint-disable*/
export default {
  init() {

    $(document).ready(function() {
      $(window).scroll(function() {
        var scroll = $(this).scrollTop();

        // Parallax effect for each layer
        $('.parallax__layer--back1').css({
          'transform': 'translateY(' + -(scroll * 0.1) + 'px)',
          'transition': 'transform 0.1s ease-out'
        });
        $('.parallax__layer--back2').css({
          'transform': 'translateY(' + -(scroll * 0.25) + 'px)',
          'transition': 'transform 0.25s ease-out'
        });
        $('.parallax__layer--front1').css({
          'transform': 'translateY(' + -(scroll * 0.3) + 'px)',
          'transition': 'transform 0.3s ease-out'
        });
        $('.parallax__layer--front2').css({
          'transform': 'translateY(' + -(scroll * 0.6) + 'px)',
          'transition': 'transform 0.3s ease-out'
        });
      });
    });

    $(".wysiwyg iframe").wrap("<div class='wysiwyg__iframe'></div>");

    let builderSlider = $('.home__participants__wrapper').slick({
      infinite: true,
      speed: 700,
      fade: false,
      arrows: true,
      nextArrow: false,
      prevArrow: false,
      vertical: true,
      slidesToShow: 1,
      slidesToScroll: 1,
    });

    $('.home__participants__prev').click(function (e) {
      e.preventDefault();
      builderSlider.slick('slickPrev');
    });

    $('.home__participants__next').click(function (e) {
      e.preventDefault();
      builderSlider.slick('slickNext');
    });

    /*** POPUP YTB ***/
    // Fonction pour afficher et gérer un popup
    function showPopup(popupId) {
      var popup = $("#" + popupId);
      var html = $("html");

      // Ajouter la classe pour bloquer le défilement
      html.addClass("popup-open");

      // Afficher le popup après le chargement de la page
      popup.removeClass("hidden");
      setTimeout(() => popup.addClass("fade-in"), 1000);

      // Fermer le popup lorsqu'on clique sur le lien de fermeture
      function closePopup() {
        popup.addClass("hidden");
        // Détacher les gestionnaires d'événements lors de la fermeture
        popup.off('click', '.close, .close-btn, .close-version', closePopup);
        // Retirer la classe pour permettre le défilement
        html.removeClass("popup-open");
        html.addClass("popup-close");
      }
      // Gestionnaire d'événements pour fermer la popup
      popup.on('click', '.close, .close-btn, .close-version', closePopup);
    }

// Appeler la fonction pour chaque popup
    showPopup("popup2");
    showPopup("popup3");


    $('.home__sponsors__container').slick({
      infinite: true,
      speed: 700,
      fade: false,
      arrows: false,
      dots: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 475,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }

      ]

    });

    const swiperImage = new Swiper(".home__race-slider", {
      loop: true,
      slidesPerView: 1,
      direction: "horizontal",
      effect: "fade",
      autoplay: true,
      speed: 900,
      fadeEffect: {
        crossFade: true,
      },
    });

    var a = 0;
    $(window).scroll(function () {

      var oTop = $('.home__numbers__item').offset().top - window.innerHeight;
      if (a == 0 && $(window).scrollTop() > oTop) {
        $('.home__numbers__label').each(function () {
          var $this = $(this),
            countTo = $this.attr('data-count');
          $({
            countNum: $this.text()
          }).animate(
            {
              countNum: countTo
            },
            {

              duration: 3000,
              easing: 'swing',
              step: function () {
                $this.text(Math.floor(this.countNum));
              },
              complete: function () {
                $this.text(this.countNum);
                //alert('finished');
              }

            }
          );
        });
        a = 1;
      }

    });

    // Animation hIntro
    let tlHeader = new TimelineMax(),
      ctrlHeader = new ScrollMagic.Controller(),
      sceneHeader;


    //tlHeader.from($('.c-nav'), 0.7, {opacity: 0, x: 400});
    tlHeader.from($('.c-header__top img'), 0.7, {opacity: 0, y: -200}, .3);
    tlHeader.from($('.c-header__bloc__title'), 0.5, {opacity: 0, y: -10}, .5);
    tlHeader.from($('.c-header__bloc__subtitle'), 0.5, {opacity: 0, y: -15}, .7);
    tlHeader.from($('.c-header__bloc__date'), 0.5, {opacity: 0, y: -15}, .9);
    tlHeader.from($('.c-header__bloc__video'), 0.5, {opacity: 0, y: -15}, .9);


    sceneHeader = new ScrollMagic.Scene({
      triggerElement: '.c-header__bloc',
      triggerHook: .7,
      reverse: false,
    }).setTween(tlHeader).addTo(ctrlHeader);


    // Animation Timer
    let tlTimer = new TimelineMax(),
      ctrlTimer = new ScrollMagic.Controller(),
      sceneTimer;

    tlTimer.from($('.home__counter__title'), 0.7, {opacity: 0, y: -100}, .3);
    tlTimer.from($('.home__race__intro-title'), 0.7, {opacity: 0, y: -100}, .3);
    tlTimer.from($('.home__intro-trakks'), 0.7, {opacity: 0, y: -100}, .3);
    tlTimer.staggerFrom($('.hurrytimer-timer'), 1, {opacity: 0, y: -55}, .2, .5);

    sceneTimer = new ScrollMagic.Scene({
      triggerElement: '.home__counter',
      triggerHook: .65,
      reverse: false,
    }).setTween(tlTimer).addTo(ctrlTimer);

    // Animation Race
    let tlRace = new TimelineMax(),
      ctrlRace = new ScrollMagic.Controller(),
      sceneRace;

    tlRace.from($('.home__race__title'), 0.7, {opacity: 0, y: -100});
    tlRace.staggerFrom($('.home__race__item'), 1, {opacity: 0, y: -55}, .2, .3);

    sceneRace = new ScrollMagic.Scene({
      triggerElement: '.home__race',
      triggerHook: .6,
      reverse: false,
    }).setTween(tlRace).addTo(ctrlRace);


    // Animation Intro
    let tlIntro = new TimelineMax(),
      ctrlIntro = new ScrollMagic.Controller(),
      sceneIntro;

    tlIntro.from($('.home__intro__img'), 0.7, {opacity: 0, x: -200});
    tlIntro.staggerFrom($('.home__intro__wrapper'), 1, {opacity: 0, y: -55}, .2, .3);

    sceneIntro = new ScrollMagic.Scene({
      triggerElement: '.home__intro',
      triggerHook: .55,
      reverse: false,
    }).setTween(tlIntro).addTo(ctrlIntro);


    // Animation Participants
    let tlParticipants = new TimelineMax(),
      ctrlParticipants = new ScrollMagic.Controller(),
      sceneParticipants;

    tlParticipants.from($('.home__participants__bloc'), 0.7, {opacity: 0, y: -50});
    tlParticipants.from($('.home__participants__bloc img'), 0.7, {opacity: 0, y: -50}, .3);
    tlParticipants.from($('.home__participants__title'), 0.7, {opacity: 0, y: -50}, .5);
    tlParticipants.from($('.home__participants__text'), 0.7, {opacity: 0, y: -50}, .7);
    tlParticipants.from($('.home__participants__infos span'), 0.7, {opacity: 0, y: -50}, .9);

    sceneParticipants = new ScrollMagic.Scene({
      triggerElement: '.home__participants',
      triggerHook: .65,
      reverse: false,
    }).setTween(tlParticipants).addTo(ctrlParticipants);


    // Animation News
    let tlNews = new TimelineMax(),
      ctrlNews = new ScrollMagic.Controller(),
      sceneNews;

    tlNews.from($('.home__news__title'), 0.7, {opacity: 0, y: -50});
    tlNews.from($('.home__news .c-btn'), 0.7, {opacity: 0, y: -50}, .3);
    tlNews.staggerFrom($('.c-cards'), 1, {opacity: 0, x: -100}, .2, .5);

    sceneNews = new ScrollMagic.Scene({
      triggerElement: '.home__news',
      triggerHook: .55,
      reverse: false,
    }).setTween(tlNews).addTo(ctrlNews);




  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js